import {Values} from '@wix/devzai-utils-common';
import {DoppeDtoUserMetaSiteType} from "./doppe-dto-user";

const DoppeAutomationHoppWixAppsPrefix = {
    CreatorsMetaSite: 'hopp_creators-',
    LinkedMetaSite: 'hopp-',
} as const;

export const DoppeAutomationTriggers = {
    ContactAdded: 'contact_added',
    SubscribeFormSubmitted: 'subscribe_form_submitted',
    ContactFormSubmitted: 'contact_form_submitted',
    PaymentReceived: 'payment_received',
} as const;

export type DoppeAutomationTriggers = Values<typeof DoppeAutomationTriggers>;

export type DoppeAutomationTriggerData =
    | DoppeAutomationTriggerData.ContactAdded
    | DoppeAutomationTriggerData.ContactFormSubmitted
    | DoppeAutomationTriggerData.SubscribeFormSubmitted
    | DoppeAutomationTriggerData.PaymentReceived;

export namespace DoppeAutomationTriggerData {
    type BaseType<T extends DoppeAutomationTriggers> = {
        type: T;
        actionId: string;
        contactList?: string;
        contactId: string;
        isNewContact: boolean;
    };

    type Payment = {
        paymentId: string;
        price: {
            value: string;
            currency: string;
        };
    };

    type Message = {
        message?: string;
    };

    export type ContactAdded = BaseType<typeof DoppeAutomationTriggers.ContactAdded>;

    export type ContactFormSubmitted = BaseType<typeof DoppeAutomationTriggers.ContactFormSubmitted> & Message;

    export type SubscribeFormSubmitted = BaseType<typeof DoppeAutomationTriggers.SubscribeFormSubmitted>;

    export type PaymentReceived = BaseType<typeof DoppeAutomationTriggers.PaymentReceived> & Message & Payment;
}

export function doppeAutomationTriggerResolveKeyForMetaSiteType (
    trigger: DoppeAutomationTriggers,
    metaSiteType: DoppeDtoUserMetaSiteType
) {
    return `${DoppeAutomationHoppWixAppsPrefix[metaSiteType]}${trigger}` as const;
}